"use strict";
/**
 * Types for ATS Admin API (organizations and jobs)
 * Shared between backend and BO frontend
 */
Object.defineProperty(exports, "__esModule", { value: true });
